export enum AnnualFeeStatus {    
    NoUpdate = 0,
    UpdateToZero = 1,
    UpdateToCentersAnnualFee = 2
}